import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import Layout from 'components/Layout';
import { useHistory } from 'react-router-dom';
import Warning from '@mui/icons-material/Warning';
import { Box, Button, Container, Typography, Link } from '@mui/material';

const UnauthorizedPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch({ type: 'FETCH_UNAUTHORIZED_PAGE' });
  }, [dispatch]);

  return (
    <Layout title={i18n.t('unauthorized.title')}>
      <Container>
        <Box
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="3rem"
            sx={{
              borderRadius: '50%',
              height: 120,
              width: 120,
              marginBottom: 4,
              backgroundColor: 'rgba(250, 82, 82, 0.08)',
            }}
          >
            <Warning sx={{ color: 'error.main', fontSize: '3rem' }} />
          </Box>
          <Typography variant="h5">
            <Box fontWeight="fontWeightBold" component="span" display="inline-block" fontSize={16}>
              {i18n.t('unauthorized.reason')}
            </Box>
          </Typography>

          <Box
            component="span"
            display="inline-block"
            fontSize={14}
            textAlign="center"
            maxWidth={460}
            margin={'25px 10px'}
          >
            <p>
              {i18n.t('unauthorized.description')}{' '}
              <Link
                underline="none"
                fontWeight="bold"
                href={`mailto:${i18n.t('unauthorized.contact')}`}
              >
                {i18n.t('unauthorized.contact')}
              </Link>
            </p>
          </Box>

          <Button
            type="button"
            variant="contained"
            color="primary"
            onClick={() => {
              history.push(buildUrl('/dashboard'));
            }}
            sx={{ textTransform: 'inherit' }}
          >
            {i18n.t('unauthorized.button')}
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default UnauthorizedPage;
